import { render, staticRenderFns } from "./GalleryChild.vue?vue&type=template&id=d9f9cbe2"
import script from "./GalleryChild.vue?vue&type=script&lang=js"
export * from "./GalleryChild.vue?vue&type=script&lang=js"
import style0 from "./GalleryChild.vue?vue&type=style&index=0&id=d9f9cbe2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports